import "react";
import "./auth-service-tools177.js";

function isVirtualColor(value) {
  return !!value && typeof value === "object" && "mantine-virtual-color" in value;
}

export { isVirtualColor };